import React from 'react';

import Console from '../../../../lib/debug';

export default class PrescriptionDropItem extends React.Component {
    handleEnter(item) {
        if (this.props.submenu || item.expand) {
            this.props.onEnter(item);
        }
    }
    handleLeave(item) {
        if (item.expand) {
            this.props.onLeave();
        }
    }
    handleSelect(item) {
        if (this.props.submenu && !item.expand) {
            this.props.onSelect(item);
        }
    }
    render() {
        Console.render('designer.PrescriptionDropItem');
        let item = this.props.item;
        let expand = item.expand ? (
            <div className="MegaDrop-item-metadata">
                <i className="mdi mdi-menu-right expand" />
            </div>
        ) : null;
        return (
            <div
                ref={this.props.itemRef}
                className={`MegaDrop-item${
                    !this.props.submenu && !item.expand ? ' disabled' : ''
                }`}
                onMouseEnter={this.handleEnter.bind(this, item)}
                onMouseLeave={this.handleLeave.bind(this, item)}
                disabled={!this.props.submenu && !item.expand}
                onClick={this.handleSelect.bind(this, item)}
            >
                <div className="MegaDrop-item-metadata">
                    <span className="MegaDrop-item-title">{item.title}</span>
                </div>
                {expand}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/designer/components/PrescriptionDrop/PrescriptionDropItem.jsx